import React, { useCallback, useState } from 'react'
import { FiChevronDown, FiChevronUp } from 'react-icons/fi'

const AccordionTwo = ({ title, customClass, onAccordionOpen, children }) => {

    const [isActive, setIsActive] = useState(false)

    const handleOpen = useCallback(() =>{
        if(!isActive){
            onAccordionOpen()
        }
        setIsActive(prev => !prev)
    },[isActive])

    return (
        <div className="accordion">
            <div className="accordion-item">
                <button className={`accordion-header text-light-blue w-full flex items-center justify-between ${customClass} ${isActive ? 'expanded' : 'collapsed'}`} onClick={handleOpen}>
                    <div className='accordion-title'>
                        <p>{title}</p>
                    </div>
                    <div className='shrink-0 accordion-arrow'>{isActive ? <FiChevronUp className='link' /> : <FiChevronDown className='link' />}</div>
                </button>
                {isActive && <div className="accordion-content px-3" style={{borderTop:'1px solid #e5e5e5'}}>{children}</div>}
            </div>
        </div>
    )
}

export default AccordionTwo